import { FC } from 'react'

interface SellerIdentityProps {
  label: string
  className?: string
}

const parseSellerIdentity = (label: string): { code: string; name: string } | null => {
  const normalized = label.trim()
  const separator = ' - '
  const index = normalized.indexOf(separator)

  if (index <= 0) {
    return null
  }

  const code = normalized.slice(0, index).trim()
  const name = normalized.slice(index + separator.length).trim()

  if (!code || !name) {
    return null
  }

  return { code, name }
}

const SellerIdentity: FC<SellerIdentityProps> = ({ label, className }) => {
  const parsed = parseSellerIdentity(label)

  if (!parsed) {
    return <span className={className}>{label}</span>
  }

  return (
    <span className={`d-inline-flex align-items-center gap-2 ${className || ''}`.trim()}>
      <span className='badge badge-light-primary fw-semibold'>{parsed.code}</span>
      <span>{parsed.name}</span>
    </span>
  )
}

export { SellerIdentity }
